const leads = {
  leadscharts: {
    chart: {
      type: "bar",
      height: 150,
    },
    plotOptions: {
      bar: {
        // borderRadius: 10,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#F96C85"],
    xaxis: {
      categories: ["Conversation", "Follow Up", "Inpipeline"],
    },
  },
  series: [
    {
      data: [400, 122, 250],
    },
  ],
};
const leadsOne = {
  leadschartsOne: {
    chart: {
      type: "bar",
      height: 150,
    },
    plotOptions: {
      bar: {
        // borderRadius: 10,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#77D882"],
    xaxis: {
      categories: ["Conversation", "Follow Up", "Inpipeline"],
    },
  },
  series: [
    {
      data: [400, 122, 250],
    },
  ],
};
const leadsTwo = {
  series: [
    {
      name: "Session Duration",
      data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10],
    },
  ],
  leadschartsTwo: {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [5, 7, 5],
      curve: "straight",
      dashArray: [0, 8, 5],
    },
    legend: {
      tooltipHoverFormatter: function (val, opts) {
        return (
          val +
          " - <strong>" +
          opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
          "</strong>"
        );
      },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    colors: ["#FFC38F"],
    xaxis: {
      categories: [
        "Jan",
        "feb",
        "march",
        "april",
        "may",
        "jun",
        "july",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec",
      ],
    },

    tooltip: {
      y: [
        {
          title: {
            formatter: function (val) {
              return val + " (mins)";
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val + " per session";
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val;
            },
          },
        },
      ],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  },
};

const leadsThree = {
  leadschartsThree : {
    chart: {
      width: 450,
      type: 'pie',
    },
    labels: ['Inpipeline', 'Follow Up', 'Schedule Service', 'Conversation'],
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 275
        },
        legend: {
          position: 'right'
        }
      }
    }]
  },
  series: [44, 55, 13, 43],
  
};

export { leads, leadsOne, leadsTwo, leadsThree };
